export class DTO {
    constructor() {
        this.id = 0;
    }

    cargarDTO(dto) {
        if (dto.id) {
            this.id = dto.id;
        }
    }

    clone(dto) {
        dto.id = this.id;
    }
}
